import React, { useContext } from 'react';
import { Icon } from '@fiverr-private/fit';
import { bool, number } from 'prop-types';
import { l_chevron_left } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import tracker from '../../../service/tracker';
import { EVENTS_MAPPING } from '../../../utils/constants';
import { CarouselContext } from '.';

const Title = ({ isNextFilterSelected, showBackButton, totalSteps }) => {
    const { filterId, subCategoryId, setStepIndex, stepIndex, stepNum } = useContext(CarouselContext);

    const clickedBack = () => {
        setStepIndex(stepIndex - 1);
        tracker.trackTileFilter(EVENTS_MAPPING.FILTERS_BACK, filterId, stepNum);
    };

    return (
        <div className="title">
            {!isNextFilterSelected && totalSteps > 1 &&
            <p>
                {showBackButton && <Icon className="icon" onClick={clickedBack} size={15}>{l_chevron_left}</Icon>}
                <span className="step-indicator">
                    <I18n k={'search_perseus.filter_tiles.step_indicator'} params={{ stepNum, totalSteps }}/>
                </span>
            </p>
            }
            <h6>
                <I18n k={`search_perseus.filter_tiles.${subCategoryId}.${filterId}`}/>
            </h6>
        </div>
    );
};

Title.propTypes = {
    isNextFilterSelected: bool,
    showBackButton: bool,
    totalSteps: number
};

export default Title;
